export default {
  "menu.login": "Login",
  "menu.dashboard": "Dashboard",
  "menu.aiRecommendation": "AI Suggestions",
  "menu.analytics": "Smart Analytics",
  "menu.stock": "Inventory",
  "menu.transaction": "Transactions",
  "menu.inventoryCheck": "Inventory Check",
  "menu.product": "Products",
  "menu.contact": "Contacts",
  "menu.settings": "Settings",
  "menu.pricing": "Pricing",
  "menu.account.logout": "Logout",

  // hideInMenu (sidebar hidden, but used for breadcrumbs/page titles)
  "menu.aiLineSetup": "LINE Setup",
  "menu.aiMonthlyReport": "Monthly Report",
};
